import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      const pagePath = `${location.pathname}${location.search}`;

      window.gtag('config', 'AW-17071176558', { page_path: pagePath });
      window.gtag('config', 'G-S4M0PM3S4W', { page_path: pagePath });
    }
  }, [location.pathname, location.search]);

  return null;
};

export default RouteChangeTracker;
